import React from "react";
import useTranslations from "../../hooks/useTranslations";
import { FrameContext } from "../../contexts/FrameContext";

const DaySchedule = (props) => {
  const { settings } = React.useContext(FrameContext);

  let content = useTranslations();

  const getButtonStyles = () => {
    if (!settings || !settings.styles || (!settings.styles.buttonBorderRadius && !settings.styles.successColor)) return null;

    let styles = {};
    if (settings.styles.buttonBorderRadius) {
      styles.borderRadius = settings.styles.buttonBorderRadius;
    }

    if (settings.styles.successColor) {
      styles.backgroundColor = settings.styles.successColor;
    }

    return styles;
  };

  const getSlotStyles = () => {
    if (!settings || !settings.styles || !settings.styles.buttonBorderRadius) return null;

    let styles = {};
    if (settings.styles.buttonBorderRadius) {
      styles.borderRadius = settings.styles.buttonBorderRadius;
    }

    return styles;
  };

  if (!props.times || !props.times.length) {
    return (
      <div className="text-center">
        {props.notAvailableMsg ? props.notAvailableMsg : props.location ? content.scheduleAppointment.locationNoAvailability : content.scheduleAppointment.agentNoAvailability}
      </div>
    );
  }

  const getClassNames = (schedule) => {
    let className = 'cts-btn-schedule';
    if(props.disabled) {
      className += ' disabled';
    }
    if(props.selectedSchedule && props.selectedSchedule.schedule.startTime === schedule.schedule.startTime && props.selectedSchedule.schedule.endTime === schedule.schedule.endTime) {
      className += ' selected';
    }
    return className;
  }

  return props.times.map((x, i) => (
    <div key={i} className="cts-schedule-slot">
      <div style={getSlotStyles()} className="cts-schedule-slot-time">
        {x.schedule.timeString}
      </div>
      <button
        tabIndex="0"
        disabled={props.disabled}
        aria-label={`${props.day} ${x.schedule.timeString}`}
        style={getButtonStyles()}
        onClick={() => props.onClick(x)}
        type="button"
        className={getClassNames(x)}
      >
        {content.scheduleAppointment.scheduleButton}
      </button>
    </div>
  ));
};

export default DaySchedule;
